export default __webpack_public_path__ + "static/media/badge-3.ae98d99f.png";